import ActionsRenderer from '@/components/helpers/renderers/ActionsRenderer'
import NumericEditor from '@/components/statistic/editors/NumericEditor'
import AG_GRID_LOCALE_RU from '@/config/locale.ru'

export default {
  getGridOptionsDefault(params) {
    return {
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        cellStyle: {
          'word-break': 'break-all',
          fontSize: '15px'
        }
      },
      localeText: AG_GRID_LOCALE_RU,
      pagination: true,
      paginationPageSize: 20,
      rowHeight: 50,
      headerHeight: 40,
      enableCellTextSelection: true,
      suppressMenuHide: true,
      suppressDragLeaveHidesColumns: true,
      frameworkComponents: {
        ActionsRenderer,
        NumericEditor
      },
      onGridSizeChanged(data) {
        data.api.sizeColumnsToFit()
      },
      ...params
    }
  },
  getDefaultActionRenderer(params) {
    return {
      headerName: '',
      field: 'actions',
      width: 100,
      cellRenderer: 'ActionsRenderer',
      suppressSizeToFit: true,
      filter: false,
      sortable: false,
      cellRendererParams: {
        ...params
      }
    }
  }
}
